import logo from './logo.svg';
import './App.css';

function Experience({ section, setSection }) {

    const experience = [
        {
            company: "Code Brew Labs Pvt. Lmt.",
            position: "Senior Software Engineer",
            duration: "SEP 2022 - Present",
            description: [
                "Led a team of 6–8 developers across multiple live products, ensuring delivery of scalable and secure web applications.",
                "Architected backend systems using Node.js and MongoDB with Redis-based caching and RabbitMQ-based message queues.",
                "Actively participated in client discussions, defining technical requirements, timelines, and deployment strategies.",
                "Leveraged AI-powered tools such as Claude AI, Cursor AI, Claude Code and GitHub Copilot to accelerate development workflows improve code quality, and streamline debugging across projects.",
            ]
        },
        {
            company: "Code Brew Labs Pvt. Lmt.",
            position: "Software Engineer",
            duration: "MAY 2019 - SEP 2022",
            description: [
                "Integrated multiple third-party APIs (crypto wallets, trading data, document storage) to enhance system capabilities.",
                "Improved performance and reduced API response times by optimizing query structure and caching strategies.",
                "Developed and deployed full-stack applications using MERN stacks.",
                "Contributed to reusable component libraries and backend modules.",
                "Collaborated closely with cross-functional teams to deliver reliable, production-grade solutions."
            ]
        },

    ]
    return (
        <>
            {/* ======= Experience Section ======= */}
            <section id="experience" className={`resume ${section == "experience" ? "section-show" : ""}`}>
                <div className="container">
                    <div className="section-title">
                        <h2>Experience</h2>
                        <p>Journey Through My Experience</p>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            {/* <h3 class="resume-title">Sumary</h3> */}
                            <div className="resume-item pb-0">
                                <h4> <a href="https://www.code-brew.com/" target="_blank" rel="noreferrer"> Code Brew Labs Pvt. Lmt. <i className="mdi mdi-open-in-new ms-2" /></a> </h4>

                                {
                                    experience.map((exp, index) => (
                                        <div key={index}>
                                            <p><em> {exp.position} [ {exp.duration} ] </em></p>
                                            <ul>
                                                {exp.description.map((desc, index) => (
                                                    <li key={index} className='my-2 fst-desc15'><i className="mdi mdi-check-circle-outline me-2 colorTheme" /> {desc}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </section>{/* End Experience Section */}
        </>
    );
}

export default Experience;
